import { http } from '../http';

export const getCompanyFromDomainService = async (email, companyTypeId) => {
  try {
    const url = `/getCompanyFromDomain?email=${email}&companyTypeId=${companyTypeId}`;
    const response = await http.get(url, {
      baseURL: process.env.USERS_SLS_BASE_URL,
    });

    if (!response?.status === 200) {
      throw new Error("Can't get companies");
    }
    return response?.data;
  } catch (e) {
    console.error('something went wrong', e);
    return false;
  }
};

export default {
  getCompanyFromDomainService,
};
